import React from 'react';
import { BrowserRouter, Route, Redirect, Switch} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import Header from './features/partials/Header';
import Footer from './features/partials/Footer';
import Home from './features/pages/Home';
//import HomeApp from './features/pages/HomeApp';
import LiabilityPolicy from './features/pages/LiabilityPolicy';
//import DashBoardApp from './features/pages/DashboardApp';
import Faq from './features/pages/Faq';
import EmailConfirmedComponent from './features/partials/EmailConfirmedComponent';
import SideNav from './features/partials/SideNav';
import './App.css'; // keep this after rsuite
import LoadScripts from './app/loadScripts';
import SignUp from './features/pages/components/profileAndLogin/SignUp';
import Profile from './features/pages/Profile';
import MyPolicies from './features/pages/myPolicies';
import AddPolicy from './features/pages/AddPolicy';
import PayInstallment from './features/pages/PayInstallment';
import PaymentFinishedNC from './features/pages/components/liabilityPolicy/paymentWithNewCard/PaymentFinishedNC';
import Team from './features/pages/Team';
import Admin from './features/pages/Admin';
import NotFound from './features/partials/NotFound';
import NewsDetails from './features/pages/components/adminModule/NewsDetails';
import PrivacyPolicy from './features/partials/PrivacyPolicy';


const App = () => {

  const userDetails = useSelector(state => state.userDetails);
  const roleName = userDetails?.roleName;
  const isAdmin = roleName?.includes('ADMIN');

  return (
    <HelmetProvider>
      <BrowserRouter>
        <div >
            <LoadScripts />
            <Header />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/faq" component={Faq} />
              <Route path="/email-confirmation" component={EmailConfirmedComponent} />
              <Route path="/team" component={Team} />
              <Route path="/news-details/:id?" component={NewsDetails} />
              <Route path="/not-found" component={NotFound} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route
                path="/app"
                render={({ match: { url } }) => (
                  <div className="side_container" >
                    <SideNav />
                    <div className="side_container-content" >
                      {/* <Route path={`${url}/`} exact component={DashBoardApp} /> */}
                      <Switch>
                        <Route path={`${url}/`} exact >
                          <Redirect to={`/app/new-policy-liability`} />
                        </Route> 
                        <Route path={`${url}/new-policy-liability`} component={LiabilityPolicy} exact/>
                        <Route path={`${url}/sign-up`} component={SignUp} exact/>
                        <Route path={`${url}/profile`} component={Profile} exact/>
                        <Route path={`${url}/my-policies`} component={MyPolicies} exact/>
                        <Route path={`${url}/add-policy`} component={AddPolicy} exact/>
                        <Route path={`${url}/pay-installment/:insuranceId?`} component={PayInstallment} exact/>
                        <Route path={`${url}/nc-payment-finished/:refreshToken?/:insuranceId?/:cashflowId?/:status?`}  component={PaymentFinishedNC} />
                        <ProtectedRouteAdmin path={`${url}/admin`}>
                          <Admin />
                        </ProtectedRouteAdmin>

                        <Route path={`${url}/*`}  >
                          <Redirect to={`/not-found`} />
                        </Route> 
                      </Switch>
                    </div>
                  </div>
                )}
              />
              <Redirect to={`/not-found`} />
            </Switch>
            <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

function ProtectedRouteAdmin({ children, ...rest }) {

  const userDetails = useSelector(state => state.userDetails);
  const roleName = userDetails?.roleName;
  const isAdmin = roleName?.includes('ADMIN');
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAdmin ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/app/profile',
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export default App;
